import React, { ReactElement } from 'react';
import DrawerInternal from '@mui/material/Drawer';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import FormatService from '../../services/format-service';
import useStylesDrawer from './drawer.styles';

const Drawer: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const CLASSNAME_MODAL_DRAWER_PAPER: string = 'modal-drawer-paper';
  const VARIANT_PERSISTENT: DrawerVariant = 'persistent';
  const VARIANT_TEMPORARY: DrawerVariant = 'temporary';
  const ANCHOR_RIGHT: DrawerAnchor = 'right';
  const ANCHOR_LEFT: DrawerAnchor = 'left';
  const SWIPE_AREA_WIDTH_DEFAULT: number = 5;

  const {
    isOpen,
    isRight,
    isSwipeable,
    isSecondary,
    className,
    onOpen,
    onClose,
    children,
  } = props;

  const { classes } = useStylesDrawer();

  const secondaryClassName: string | undefined = isSecondary ? classes.drawerPaperSecondary : undefined;

  return (
    isSwipeable ? (
      <SwipeableDrawer
        open={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        variant={VARIANT_TEMPORARY}
        ModalProps={{
          keepMounted: true,
        }}
        swipeAreaWidth={SWIPE_AREA_WIDTH_DEFAULT}
        anchor={isRight ? ANCHOR_RIGHT : ANCHOR_LEFT}
        classes={{
          root: classes.drawer,
          paper: FormatService.formatClassNames(
            classes.drawerPaper, secondaryClassName, CLASSNAME_MODAL_DRAWER_PAPER, className,
          ),
        }}
      >
        {children}
      </SwipeableDrawer>
    ) : (
      <DrawerInternal
        open={isOpen}
        variant={VARIANT_PERSISTENT}
        anchor={isRight ? ANCHOR_RIGHT : ANCHOR_LEFT}
        classes={{
          root: classes.drawer,
          paper: FormatService.formatClassNames(classes.drawerPaper, secondaryClassName, className),
        }}
      >
        {children}
      </DrawerInternal>
    )
  );
});

export default Drawer;
